import {useParams} from "react-router-dom";
import ImprovedConditionalPaymentProfileCard from "../../../components/ImprovedConditionalPaymentProfileCard";
import ProtectedRoute from "../../../components/ProtectedRoute";
import List from "./components/List";

const GamesList = () => {
  const {provider, category} = useParams();

  return (
    <ProtectedRoute>
      <ImprovedConditionalPaymentProfileCard />
      <div className="games-list">
        <List
          provider={provider ?? "all"}
          category={category}
        />
      </div>
    </ProtectedRoute>
  );
};

export default GamesList;
